import { some } from 'lodash';

export const isLocationInEstimates = (
  locationDeliveryEstimates: { locationId: string }[],
  selectedLocationId: string | null,
) => some(locationDeliveryEstimates, { locationId: selectedLocationId });
